import { UPDATE_LVT_REPORT, RESET_LVT_REPORT } from '../action-type';

const initialState = {
  data: {
    stepOneTogg: ['1', '2', '3', '4', '5', '6', '7', '8'],
    stepThreeTogg: ['1', '2', '3', '4'],
    stepFourTogg: ['6', '7', '8', '10'],
    attachments: [],
    Allimagedescription: {},
    footerLogo: [],
  },
};

const lvtReport = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LVT_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case RESET_LVT_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default lvtReport;